import { Outlet, useMatch } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './common/Footer';
import ScrollToTop from './common/ScrollToTop';

function App() {
  // Product detail page ("/products/:categorySlug/:index") pe header nahi dikhana
  const isProductDetail = useMatch('/products/:categorySlug/:index');

  return (
    <>
      <ScrollToTop />
      {!isProductDetail && <Header />}
      <main >
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default App;
